import React, { Component } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
} from "reactstrap";
import ButtonExt from '../controls/ButtonExt'
import * as common from '../../lib/common'
import {BtnPermissions} from "../../lib/BtnPermissions";
import AppConfig from "../../config/app";

export default class ListCustomers extends Component {
  constructor(props) {
    super(props);
  }
  onClose = () => {
    this.props.onClose()
  }
  render() {
    const { 
      customers,
      order,
    } = this.props
    const isSendAvailable = (trangThai) => {
      if (!trangThai || trangThai == AppConfig.CUSTOMER_MARKETING_STATUS.ChuaGui) {
        return true
      }
      return false
    }
    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isOpen} size="lg" className="modal-md" modalClassName={"order-approve-cfm"}>
          <ModalHeader>Danh sách nhà thuốc [<span className={"text-danger"}>{order ? order.MaDonHang : ""}</span>]</ModalHeader>
          <ModalBody>
          <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30" className="text-center table-border-right">#</th>
                    <th scope="col" width="80" className="text-center table-border-right">Mã</th>
                    <th scope="col" width="100" className="text-center table-border-right">Điện thoại</th>
                    <th scope="col" width="200" className="text-left table-border-right">Tên/ Địa chỉ</th>
                    <th scope="col" width="100" className="text-center table-border-right">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {customers && !!customers.length && (
                    customers.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center table-border-right">{(idx + 1)}</td>
                        <td className="text-center table-border-right">{res.Ma}</td>
                        <td className="text-center table-border-right">{res.DienThoai}</td>
                        <td className="text-left table-border-right">
                          <span className={"font-weight-bold"}>{res.Ten}</span>
                          <div className={"text-muted ml-1"}>{res.DiaChi}</div>
                        </td>
                        <td className="text-center table-border-right">
                          <div>{common.getCustomerMarketingStatusText(res.TrangThai, true)}</div>
                          {isSendAvailable(res.TrangThai) && (
                            <ButtonExt
                              size="md" btnClass="btn btn-green mr-1" btnClick={() => this.props.onSendClick(order, res)}
                              iconClass="fa-paper-plane" displayText="Gửi"
                              permission={BtnPermissions.DonHang.SAVE_ORDER} />
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            <div className="col-sm-12 mt-2 pl-0 pr-0">
              <div className="btn-group float-right" role="group">
                <Button className="btn btn-secondary" onClick={() => this.onClose()}>
                  <i className="fa fa-close"></i><span className="d-none d-sm-inline">&nbsp;Đóng</span></Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/MarketingOrders/_ListCustomers.js